<template>
	<div class="form-checkbox">
		<label :for="name">
			<input
				type="checkbox"
				:name="name"
				:id="name"
				:value="value"
				:checked="value"
				@change="onChange"
			/>
			<span></span>
			<div class="form-checkbox__label"><slot/></div>
		</label>
	</div>
</template>

<script>
export default {
	props: ['name', 'value'],
	methods: {
		onChange () {
			this.$emit('input', !this.value);
		},
	},
};
</script>

<style lang=less scoped>
	@import (reference) '../assets/less/default.less';

	.form-checkbox { margin-top: 1.1rem; text-align: left;
		input { display: none; }
		input + span { display: inline-block; .size(25px); margin-right: 0.5rem; border: 3px solid white; background-color: #fff; vertical-align: middle;
			@media @mobile { vertical-align: top; }
		}
		input:checked + span { background-color: @blue; }
		label { display: inline-block; }
		&__label { display: inline-block; color: @grey; opacity: .6; vertical-align: middle; }
	}
</style>



// WEBPACK FOOTER //
// src/components/BaseCheckbox.vue